import { render } from "./MainBeachSuperyachtMarinaAssetTypeDesktop.vue?vue&type=template&id=cd393ac4"
import script from "./MainBeachSuperyachtMarinaAssetTypeDesktop.vue?vue&type=script&lang=js"
export * from "./MainBeachSuperyachtMarinaAssetTypeDesktop.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/mbsm-pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__